import { Injectable } from '@angular/core';

import { Observable, Observer, Subscriber } from 'rxjs';

import * as _ from 'lodash';

import { LanguageService } from './language-service';
import { Page, Language, SearchResult, Expertise } from './../data';
import { PageQuery, ExpertiseQuery } from './../queries';

@Injectable()
export class SearchService {
  private mLang: Observable<string>;

  constructor(private languageService: LanguageService) {
    this.mLang = this.languageService.getCurrentLang();
  }

  public search(searchText: string) {
    return this.mLang.switchMap(lang => {
      let pages: Observable<SearchResult[]> = new PageQuery()
        .search(searchText, lang)
        .notContainedIn(Page.PERMALINK_KEY, [Page.EXPERTISE_PERMALINK, Page.HOME_PERMALINK, Page.SEARCH_PERMALINK])
        .rx()
        .find()
        .map(
          o => o.map(v => {
            return {
              title: v.getTitle(lang),
              description: v.getContent(lang),
              link: '/' + v.permalink
            }
          })
      );

      let expertises: Observable<SearchResult[]> = new ExpertiseQuery()
        .search(searchText, lang)
        .includeTranslation(Expertise.ICON_KEY, lang)
        .rx()
        .find()
        .map(
          o => o.map(v => {
            return {
              title: v.getTitle(lang),
              description: v.getDescription(lang),
              icon: v.getIcon(lang),
              link: '/expertise/' + v.id
            }
          })
      );

      return Observable.combineLatest(pages, expertises).map(o => _.flatten(o));
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/search-service.ts